// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'speaker-mute';

export const Component = () => (
  <path d='m17.74 7.173 1.005-1.437v14.416c0 .43-.144.766-.432 1.053a1.408 1.408 0 0 1-1.054.432c-.335 0-.67-.096-.91-.335L10.985 16.8l.575-.766 5.412 4.501c.048.048.144.096.287.096.336 0 .48-.143.48-.479V7.173Zm-9.58 8.573-.67.958H5.959a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67V8.85c0-.239.096-.479.287-.67a.946.946 0 0 1 .67-.288h4.934l5.46-4.597c.239-.144.479-.24.719-.288L15.44 5.353 11.227 8.85H5.959v6.897h2.203-.001Zm11.4-13.65c.143.144.19.24.19.383 0 .144-.047.24-.095.287L5.862 22.402a.435.435 0 0 1-.383.192c-.335 0-.479-.144-.479-.48 0-.143.048-.238.096-.287L18.841 2.191A.435.435 0 0 1 19.224 2c.048 0 .144.048.335.096Z' />
);

export const viewBox = '0 0 25 25';
